import { render } from "./FElectronicaViewGNV.vue?vue&type=template&id=6b0444e6&scoped=true"
import script from "./FElectronicaViewGNV.vue?vue&type=script&lang=js"
export * from "./FElectronicaViewGNV.vue?vue&type=script&lang=js"

import "./FElectronicaViewGNV.vue?vue&type=style&index=0&id=6b0444e6&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0444e6"]])

export default __exports__